import { toast } from "react-toastify";
import {
  fetchDailyGSTReportSheetFailure,
  fetchDailyGSTReportSheetStart,
  fetchDailyGSTReportSheetSuccess,
  fetchDailyOtherReportSheetFailure,
  fetchDailyOtherReportSheetStart,
  fetchDailyOtherReportSheetSuccess,
  fetchDailyReportSheetFailure,
  fetchDailyReportSheetStart,
  fetchDailyReportSheetSuccess,
} from "./reducer";
import {
  getDailyGSTReportService,
  getDailyOtherReportService,
  getDailyReportService,
} from "../../Services/ReportService";

// //thunk for fetch the category list
export const fetchDailyOtherChargesReport =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchDailyOtherReportSheetStart());
      const response = await getDailyOtherReportService(params);

      if (response) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchDailyOtherReportSheetSuccess({
            report: response,
          })
        );

        const blob = response.data;
        const headers = response.headers;


        let fileName = "DailyTripReport.xlsx";
        const contentDisposition = headers["content-disposition"];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match.length > 1) {
            fileName = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([blob]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Set filename

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success(
          "Sales Invoice(Other Charges) Report downloaded successfully"
        );
      } else {
        dispatch(fetchDailyOtherReportSheetFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchDailyOtherReportSheetFailure(error));
    }
  };
